import React from 'react';
import { HeroContainer, HeroImg } from './CareersHero.style';

interface CareersHeroProps {
  img: string;
}

const CareersHero: React.FC<CareersHeroProps> = ({ img }) => {
  return (
    <HeroContainer>
      <HeroImg img={img} />
    </HeroContainer>
  );
};

export default CareersHero;
